import React from 'react';
import { NavDropdown, Navbar, Nav, Offcanvas, Container, DropdownButton } from 'react-bootstrap';
import tringLogo from '../images/tring.png';
import './Navbar.css';

const NavbarComponent = () => {
    const userData = localStorage.getItem('userData');
    return (
        <Navbar expand="lg" className="bg-body-tertiary bg-warninng" >
            <Container fluid>
                <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-lg`}></Navbar.Toggle>
                {userData != null ?
                    <Navbar.Brand href="/user/prediction-number"><img style={{ width: "70px", marginLeft: "10px" }} src={tringLogo} alt='tring logo' /></Navbar.Brand>
                    :
                    <Navbar.Brand href="/"><img style={{ width: "70px", marginLeft: "10px" }} src={tringLogo} alt='tring logo' /></Navbar.Brand>
                }
                <Navbar.Offcanvas
                    id={`offcanvasNavbar-expand-lg`}
                    aria-labelledby={`offcanvasNavbarLabel-expand-lg`}
                    placement="start"
                >
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title id={`offcanvasNavbarLabel-expand-lg`}>
                            <img style={{ width: "70px" }} src={tringLogo} alt='tring logo' />
                        </Offcanvas.Title>
                    </Offcanvas.Header>

                    <Offcanvas.Body>
                        <Nav className="justify-content-start flex-grow-1 pe-5">
                            {
                                userData != null ?
                                    <>
                                        <Nav.Link href="/user/prediction-number">Predict Your Number</Nav.Link>
                                        <hr />
                                        <Nav.Link href="/user/history">History</Nav.Link>
                                        <hr />
                                        <Nav.Link href="/prizes">Prizes</Nav.Link>
                                        <hr />
                                        <Nav.Link href="/user/settings-notification">Settings | Notification</Nav.Link>
                                        <hr />
                                    </>
                                    :
                                    <>
                                        <Nav.Link href="#home" >Home</Nav.Link>
                                        <hr />
                                        <Nav.Link href="#how-it-works">How it Works ?</Nav.Link>
                                        <hr />
                                        <Nav.Link href="#prizes-list">Prizes List</Nav.Link>
                                        <hr />
                                    </>
                            }
                        </Nav>
                        <Nav>
                            <DropdownButton
                                style={{ marginRight: "40px" }}
                                variant="success"
                                title={
                                    userData != null
                                        ? userData
                                        : "Login"
                                }
                                align="end"
                                id={`offcanvasNavbarDropdown-expand-lg`}
                            >
                                {userData != null ? (
                                    <>
                                        <NavDropdown.Item
                                            href="/"
                                            onClick={() => {
                                                localStorage.clear();
                                            }}
                                        >
                                            Logout
                                        </NavDropdown.Item>
                                        <NavDropdown.Item href="/home">Go to Website</NavDropdown.Item>
                                    </>
                                ) : (
                                    <div>
                                        <NavDropdown.Item href="/user/login">Login</NavDropdown.Item>
                                        <NavDropdown.Item href="/user/register">Sign Up</NavDropdown.Item>
                                    </div>
                                )}
                            </DropdownButton>
                            <hr />
                        </Nav>
                    </Offcanvas.Body>
                </Navbar.Offcanvas>
            </Container>
        </Navbar>
    );
};

export default NavbarComponent;
